import axios from '@/http/index';

const base = '';
// 删除快捷收银记录
export const deleteQuickOrder = (params) => axios.get(`${base}/erp/quickCash/deleteOrder`, params).then((res) => res.data);
// 赊账记录
export const getBillRecord = (param) => axios.get(`${base}/erp/account/getAccountListByCustomerNew`, param).then((res) => res.data);
// 获取用户信息
export const getMemberInfo = (param) => axios.get(`${base}/erp/customerOrder/getMemberCardMsg`, param).then((res) => res.data);
// 删除班次
export const getDeleteClass = (param) => axios.get(`${base}/erp/technicianClass/deleteClass`, param).then((res) => res.data);
// 删除服务订单
export const deleteOrder = (params) => axios.get(`${base}/erp/customerOrder/deleteOrder`, params).then((res) => res.data);
// 记录列表详情
export const getDetails = (param, url) => {
  if (url == 1) {
    return axios.get(`${base}/erp/statistics/toCaRDetails`, param).then((res) => res.data);
  } if (url == 2) {
    return axios.get(`${base}/erp/speedProduct/getOrderMsg`, param).then((res) => res.data);
  } if (url == 3) {
    return axios.get(`${base}/erp/package/getOrderMsg`, param).then((res) => res.data);
  }
};
// 获取扫码支付二维码图片
export const getEqcodeImage = (param) => axios.get(`${base}/erp/authorize/getQRCode4Refund`, param).then((res) => res.data);
// 获取扫码支付二维码图片
export const getPayStatus = (param) => axios.get(`${base}/erp/scanPay/getRefundStatus`, param).then((res) => res.data);

// 确认还款
export const comfirmHk = (param) => axios.post(`${base}/erp/account/saveOrUpate4Refund`, param).then((res) => res.data);
// 还款记录
export const getHkRecord = (param) => axios.get(`${base}/erp/account/getAccountRefundNew`, param).then((res) => res.data);
// 打印
export const printOrder = (params) => axios.get(`${base}/erp/print/printOrder`, params).then((res) => res.data);
// 是否设置了打印机
export const hasPrintSet = (params) => axios.get(`${base}/erp/print/hasPrintSet`, params).then((res) => res.data);
// 获得新增会员跳转链接
export const getMemberUrl = (params) => axios.get(`${base}/erp/member/getMemberUrl`, params).then((res) => res.data);
// 获得主题编号
export const getStyleIndex = (params) => axios.get(`${base}/erp/home/getStyleIndex`, params).then((res) => res.data);
// 保存主题编号
export const saveStyleIndex = (params) => axios.get(`${base}/erp/home/saveStyleIndex`, params).then((res) => res.data);
// （结算）扫码支付--获取订单号
export const getOrderCode = (params) => axios.get(`${base}/erp/payInfo/getOrderCode`, params).then((res) => res.data);
// （结算）扫码支付--获取支付状态
export const getScanPayStatus = (params) => axios.get(`${base}/erp/payInfo/getScanPayStatus`, params).then((res) => res.data);
// （结算）扫码支付--3.6.0
export const newBarCodePay = (params) => axios.get(`${base}/erp/payInfo/barCodePay`, params).then((res) => res.data);
// 获取商家可支付方式：默认支付(0:未设置 2:通联支付,4:微信,5:支付宝,6:(包括支付宝，微信))
export const getPaySet = (params) => axios.get(`${base}/erp/payInfo/getPaySet`, params).then((res) => res.data);
// 退出登录
export const getOutLogin = (param) => axios.get(`${base}/erp/login/out`, param).then((res) => res.data);
// 获得erp登录rl域名前缀
export const getErpLoginUrl = (param) => axios.get(`${base}/urlApi/79B4DE7C/getErpLoginUrl`, param).then((res) => res.data);

// (4.7.0)获得顾客信息列表
export const getCustomerMsgList = (params) => axios.get(`${base}/erp/customer/getCustomerMsgList`, params).then((res) => res.data);

// (5.7)校验会员卡支付密码（0：失败，1：正确）
export const validMemberCardPayPwd = (params) => axios.post(`${base}/erp/payInfo/validMemberCardPayPwd`, params).then((res) => res.data);

// （5.9）（合计）通过客户手机号查询对应的挂账数据
export const getAccountListByCustomerSum = (params) => axios.get(`${base}/erp/account/getAccountListByCustomerSum`, params).then((res) => res.data);

// （5.9）(合计)通过手机号查询对应的挂账还款数据
export const getAccountRefundSum = (params) => axios.get(`${base}/erp/account/getAccountRefundSum`, params).then((res) => res.data);

// (3.8.0)获得店铺结算设置信息
export const getPayCodeList = (params) => axios.get(`${base}/erp/payInfo/getPayTypeSetList`, params).then((res) => res.data);

// （6.4）查询顾客是否已经存在(有数据则存在，没有数据则不存在)
export const fetchPolice = (param) => axios.get(`${base}/erp/customer/upload/fetch-police`, param).then((res) => res.data);

// （6.8）删除顾客信息
export const deleteCustomerInfo = (param) => axios.post(`${base}/erp/customer/deleteCustomerInfo`, param).then((res) => res.data);
